import { ComponentType, createContext, useContext } from "react"

import { BuildingReferenceObj } from "scrivito/Objs/BuildingReference/BuildingReferenceObjClass"
import { ProductObj } from "scrivito/Objs/Product/ProductObjClass"
import { ProductBaseVariantObj } from "scrivito/Objs/ProductBaseVariant/ProductBaseVariantObjClass"
import { AttachmentType } from "shared/types/__generated__/graphql"

import { AggregatedProductData } from "entities/products/types/AggregatedProductData"
import { ProductQuickInfos } from "entities/products/types/QuickInfos"

export interface ProductPageContextType {
  productType: string
  variantKey: string

  productData: AggregatedProductData
  productObj: ProductObj | null
  productBaseVariantObj: ProductBaseVariantObj | null

  buildingReferenceObjs?: BuildingReferenceObj[]
  buildingReferenceItemRenderer?: ComponentType<{
    buildingReferenceObj: BuildingReferenceObj
  }>

  getFiles: (args: {
    productType: string
    parentProductType?: string
  }) => AttachmentType[] | undefined
  getQuickInfos: (args: {
    productType: string
    parentProductType?: string
  }) => ProductQuickInfos | undefined

  productImageUrl?: string

  onConfigure?: () => void
  onDimension?: () => void
  onDownloadPDF?: () => void
  onToggleFavorite?: () => void
  onZoomProductImage?: () => void
  onAddToProject?: () => void
  isFavorited?: boolean

  isAuthenticated?: boolean
}

export const ProductPageContext = createContext<ProductPageContextType | null>(
  null
)

export const useProductPageContext = () => {
  const context = useContext(ProductPageContext)
  if (!context) {
    throw new Error(
      "useProductPageContext must be used within a ProductPageProvider"
    )
  }
  return context
}
